import './style.fr.less';



// WEBPACK FOOTER //
// ./src/customer/styles/style.fr.js